import {useState } from "react";
import axios from "axios";
import { BASE_URL } from "apiConfig";


const useSearchTopic = () => {
  
  const [topicList, setContent] = useState(null);
   
  const [error, setError] = useState(null);
  const [loadingTopic,setLoading] = useState(true)

  
  const searchTopic = async (letter) =>
    {
      setLoading(true)
      try {
        const response = await axios.get(`${BASE_URL}/searchTopic/`, {
          params: {
            letter: JSON.stringify(letter),
          },
        });
    
        if (response.status === 200) {
          
          // Data found, set the topicList state
  
          setContent(response.data);
          setLoading(false)
          setError(null); // Clear any previous error
        } else if (response.status === 404) {
          // No data found, handle this case as needed

          setContent(null); // Clear any previous data
          setError("No data found");

        } else {
          // Handle other response status codes if needed

          setContent(null); // Clear any previous data
          setError("Error retrieving data");
         
        }
      } catch (err) {
        // Handle network or request error
        setContent(null); // Clear any previous data
        setError("Error retrieving Watchlist data");
        
      }
    };


  return {searchTopic, topicList, error,loadingTopic};
};

export default useSearchTopic;